import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  loadingWrap: {
    position: 'relative',
    width: ({ width }) => width ?? 200,
    height: ({ height }) => height ?? 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  loadingContent: {
    marginLeft: 2,
    marginRight: 2,
    width: ({ size }) => size ?? 6,
    height: ({ size }) => size ?? 6,
    backgroundColor: ({ color }) => theme.colors[color] ?? color ?? theme.colors.brandMedium,
    borderRadius: '50%',
    animation: '0.6s infinite alternate $fade',
  },

  loadingContent2: { animationDelay: '0.2s' },
  loadingContent3: { animationDelay: '0.4s' },

  '@keyframes fade': {
    from: { opacity: 1 },
    to: { opacity: 0.44 },
  },
}));

const Loading = React.forwardRef((props, ref) => {
  const { color, size, width, height, ...otherProps } = props;

  const classes = useStyles({ color, size, width, height });
  return (
    <div className={classes.root} {...otherProps} ref={ref}>
      <div className={classes.loadingWrap}>
        <div className={classes.loadingContent} />
        <div className={classnames(classes.loadingContent, classes.loadingContent2)} />
        <div className={classnames(classes.loadingContent, classes.loadingContent3)} />
      </div>
    </div>
  );
});

Loading.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};
Loading.defaultProps = {
  color: undefined,
  size: undefined,
  width: undefined,
  height: undefined,
};

export default Loading;
